<template>
  <div class="container">
    <div :id="id" :option="option"></div>
  </div>
</template>
<script>
import HighCharts from 'highcharts'
import { mapGetters } from 'vuex'
export default {
  props: {
    id: {
      type: String,
    },
    //option 是图表的配置数据
    option: {
      type: Object,
    },
    bg: {
      type: Boolean,
    },
    alarmData: {
      type: Array,
    },
    colorData: {
      type: Array,
    },
  },
  data() {
    return {
      chart: {},
    }
  },
  methods: {
    initChart() {
      if (this.isDefaultTheme) {
        this.option.plotOptions.pie.dataLabels.color = '#333'
        this.option.legend.itemStyle.color = '#333'
      } else {
        this.option.plotOptions.pie.dataLabels.color = '#fff'
        this.option.legend.itemStyle.color = '#fff'
      }
      this.chart = new HighCharts.chart(this.id, this.option)
    },
  },
  mounted() {
    // 根据整体颜色设置饼图颜色
    if (this.option.chart !== undefined) {
      this.$nextTick(() => {
        // this.option.series[0].data = this.alarmData
        this.initChart()
      })
    }
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
  watch: {
    bg: {
      // 监听深/浅色 变化饼图颜色
      handler(val) {
        if (this.isDefaultTheme) {
          this.option.plotOptions.pie.dataLabels.color = '#333'
          this.option.legend.itemStyle.color = '#333'
        } else {
          this.option.plotOptions.pie.dataLabels.color = '#fff'
          this.option.legend.itemStyle.color = '#fff'
        }
        HighCharts.chart(this.id, this.option)
      },
    },
    options: {
      handler(val) {
        HighCharts.chart(this.id, this.option)
      },
    },
    alarmData: {
      handler(val) {
        this.initChart()
        HighCharts.chart(this.id, this.option)
      },
    },
    colorData: function() {
      this.option.plotOptions.pie.color = this.colorData
      HighCharts.chart(this.id, this.option)
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  height: 100%
#equipmentNum
  width: 100%
  height: 100%
#equipmentStatu
  width: 100%
  height: 100%
#equipmentRun
  width: 100%
  height: 100%
#onlineChartId
  width: 100%
  height: 100%
@media screen and (max-height: 902px)
  #test
    height: 420px
  #alarmsChart
    height: 420px
@media screen and (max-height: 768px)
  #test
    height: 320px
  #alarmsChart
    height: 300px
</style>
